import { promotions } from '@/mocks/promotions';

export default function PromotionsSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            限时优惠活动
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            多重优惠回馈新老玩家，丰厚奖励等您来拿
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {promotions.map((promo) => {
            const isAccent = promo.color === 'accent';
            return (
              <div
                key={promo.id}
                className="group flex items-start gap-4 p-6 rounded-lg bg-background-100 hover:bg-background-200/80 transition-all duration-300 cursor-pointer"
              >
                <div
                  className={`w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-lg ${
                    isAccent
                      ? 'bg-accent-100 text-accent-600'
                      : 'bg-primary-100 text-primary-600'
                  } group-hover:scale-110 transition-transform duration-300`}
                >
                  <i className={`${promo.icon} text-xl`}></i>
                </div>
                <div>
                  <h3 className="text-base font-semibold text-foreground-900 mb-1">
                    {promo.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {promo.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}